// Press coverage manifest — canonical source of truth for every real-world
// media mention of Shantanu Netralaya.  Add new entries here as they come
// in; the NewspaperFeature component + Press / DrManisha / squint pages all
// consume this list.
//
// Rules:
//  - `id` must be unique + kebab-case (used as a URL fragment / anchor).
//  - `imageFull` is the full-page scan (proof-of-print).
//  - `imageClose` is the cropped high-resolution article shot used inside
//    hero cards + on mobile.
//  - `pullQuote` is a single 12-20 word sentence used as the design's
//    biggest visual weight.  Keep it factual, not marketing-speak.

export const PRESS_MENTIONS = [
  {
    id: "dainik-jagran-purvanchal-25-jul-2026",
    masthead: "Dainik Jagran",
    mastheadShort: "Jagran",
    edition: "Purvanchal Jagran, Varanasi City Edition",
    date: "2026-07-25",
    dateLabel: "25 July 2026",
    language: "hi",
    // Article headline as printed (Hindi) and a short English translation
    // for meta description + English readers.
    titleHi:
      "डॉ. मनीषा मिश्रा की पहल से पूर्वांचल में आधुनिक स्क्विंट सर्जरी हुई अधिक सुलभ",
    titleEn:
      "Dr. Manisha Mishra's initiative makes modern squint surgery more accessible across Purvanchal",
    pullQuoteHi:
      "आधुनिक सर्जिकल तकनीकों, सटीक नेत्र परीक्षण और व्यक्तिगत उपचार योजना की सहायता से विभिन्न आयु वर्ग के मरीजों का सफल उपचार किया जा सकता है।",
    pullQuoteEn:
      "With modern surgical techniques, precise eye examination and personalised treatment plans, successful outcomes are possible for squint patients across all age groups.",
    subject: {
      kind: "Physician",
      name: "Dr. Manisha Mishra",
      role: "Squint & Cataract Surgeon",
      pageHref: "/team/dr-manisha-mishra",
    },
    topic: "Squint surgery (strabismus)",
    topicHref: "/squint-surgery-in-varanasi",
    // 10 districts the print edition was distributed across.  Rendered as
    // a pill list under the pull quote — proves geographic reach for both
    // patients (trust) and Google's E-E-A-T scoring.
    districts: [
      "Varanasi",
      "Chandauli",
      "Ghazipur",
      "Jaunpur",
      "Bhadohi (Sant Ravidas Nagar)",
      "Mirzapur",
      "Sonbhadra",
      "Azamgarh",
      "Mau",
      "Ballia",
    ],
    imageFull:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_shantanu-netralaya/artifacts/8ccok4dp_117cc6e4-be77-451e-bca4-836f1a8077f2.jpeg",
    imageClose:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_shantanu-netralaya/artifacts/ei56eq54_IMG_3070.jpeg",
    epaperUrl:
      "https://epaper.jagran.com/epaper/25-jul-2026-45-varanasi-city-edition-varanasi-city.html",
    // 5-paragraph excerpted / typeset version of the printed article.
    // Kept as an array so the renderer can format each paragraph
    // individually and search engines can index the Hindi text.
    bodyParagraphsHi: [
      "वाराणसी। भेंगापन (स्क्विंट) केवल आंखों के टेढ़ेपन तक सीमित समस्या नहीं है, बल्कि यह दोनों आंखों के समन्वय, गहराई का सही आकलन (Depth Perception), दृष्टि और व्यक्ति के आत्मविश्वास को भी प्रभावित कर सकता है। नेत्र विशेषज्ञों के अनुसार, समय पर जांच और उचित उपचार से अधिकांश मरीजों में उत्कृष्ट परिणाम प्राप्त किए जा सकते हैं।",
      "पूर्वांचल में पिछले कुछ वर्षों के दौरान स्क्विंट सर्जरी की आधुनिक सुविधाएं पहले की तुलना में अधिक सुलभ हुई हैं। इस दिशा में वाराणसी के कबीर नगर स्थित शान्तनु नेत्रालय में कार्यरत स्क्विंट एवं मोतियाबिंद सर्जन डॉ. मनीषा मिश्रा द्वारा आधुनिक जांच, वैज्ञानिक मूल्यांकन और उन्नत स्क्विंट सर्जरी की सुविधाओं को विकसित करने के प्रयास उल्लेखनीय रहे हैं। उनके साथ मोतियाबिंद एवं रेटिना रोग विशेषज्ञ डॉ. शान्तनु गुप्ता भी मरीजों के समग्र नेत्र उपचार में सक्रिय भूमिका निभा रहे हैं, जिससे एक ही संस्थान में व्यापक नेत्र चिकित्सा सेवाएं उपलब्ध हो रही हैं।",
      "संस्थान की चिकित्सा परंपरा वरिष्ठ नेत्र विशेषज्ञ डॉ. राजेश गुप्ता के नैतिक मार्गदर्शन से प्रेरित है। उन्होंने अपने लंबे चिकित्सकीय जीवन में बड़ी संख्या में मरीजों की सेवा की है तथा मारवाड़ी हिन्दू अस्पताल में वर्षों तक आर्थिक रूप से कमजोर वर्ग के लोगों के उपचार में महत्वपूर्ण योगदान दिया। उसी सेवा-भाव, पारदर्शिता और नैतिक चिकित्सा की परंपरा को आगे बढ़ाने का प्रयास शान्तनु नेत्रालय द्वारा किया जा रहा है।",
      "विशेषज्ञों का कहना है कि यह धारणा सही नहीं है कि भेंगापन केवल बच्चों में होता है या बढ़ती उम्र में इसका उपचार संभव नहीं रहता। आधुनिक सर्जिकल तकनीकों, सटीक नेत्र परीक्षण और व्यक्तिगत उपचार योजना की सहायता से विभिन्न आयु वर्ग के मरीजों का सफल उपचार किया जा सकता है। यदि किसी व्यक्ति की आंखें बार-बार टेढ़ी दिखाई दें, दो-दो दिखाई दें, या आंखों के संरक्षण में असामान्यता महसूस हो, तो शीघ्र नेत्र विशेषज्ञ से परामर्श लेना चाहिए। समय पर उपचार से आंखों का संतुलन बेहतर होने के साथ कई मामलों में दृष्टि की गुणवत्ता और जीवन की गुणवत्ता में भी उल्लेखनीय सुधार संभव है।",
      "नेत्र विशेषज्ञों का मानना है कि पूर्वांचल में आधुनिक स्क्विंट सर्जरी सेवाओं की उपलब्धता बढ़ने से अब क्षेत्र के अनेक मरीजों को उपचार के लिए बड़े महानगरों की ओर जाने की आवश्यकता पहले की तुलना में काफी कम हुई है। इससे मरीजों को गुणवत्तापूर्ण उपचार अपने ही क्षेत्र में उपलब्ध हो रहा है।",
    ],
  },
];

// Convenience selectors used across pages.
export const getPressMentionById = (id) => PRESS_MENTIONS.find((p) => p.id === id) || null;
export const getPressMentionsForSubject = (pageHref) =>
  PRESS_MENTIONS.filter((p) => p.subject?.pageHref === pageHref);
export const getPressMentionsForTopic = (topicHref) =>
  PRESS_MENTIONS.filter((p) => p.topicHref === topicHref);

// ---------------------------------------------------------------------------
// Placeholder scaffolds — copy any of these blocks into PRESS_MENTIONS above,
// swap the fields, and it will auto-render on /press and the doctor / topic
// pages.  DO NOT enable an entry until you have the real print scan / e-paper
// URL — publishing empty placeholders will hurt E-E-A-T trust signals.
//
// Template A — Hindi print daily (Dainik Jagran / Amar Ujala / Hindustan)
// -------------------------------------------------------------------
// {
//   id: "amar-ujala-varanasi-XX-mmm-2026",
//   masthead: "Amar Ujala",
//   mastheadShort: "AU",
//   edition: "Varanasi City Edition",
//   date: "2026-MM-DD",
//   dateLabel: "DD Month 2026",
//   language: "hi",
//   titleHi: "हिन्दी शीर्षक यहाँ",
//   titleEn: "English translation of the headline",
//   pullQuoteHi: "एक-दो पंक्ति का हिन्दी उद्धरण।",
//   pullQuoteEn: "One-two sentence English translation of the pull quote.",
//   subject: { kind: "Physician", name: "Dr. Shantanu Kumar Gupta", role: "Cataract Surgeon", pageHref: "/about" },
//   topic: "Topic name",
//   topicHref: "/expertise/slug",
//   districts: ["Varanasi", "Chandauli"],
//   imageFull: "https://…/full-page-scan.jpeg",
//   imageClose: "https://…/close-crop.jpeg",
//   epaperUrl: "https://epaper.…",
//   bodyParagraphsHi: ["पैराग्राफ 1", "पैराग्राफ 2"],
// },
//
// Template B — English online outlet (Times of India / Hindustan Times / TheHealthSite)
// -------------------------------------------------------------------
// {
//   id: "toi-varanasi-XX-mmm-2026",
//   masthead: "The Times of India",
//   mastheadShort: "TOI",
//   edition: "Varanasi / Health section",
//   date: "2026-MM-DD",
//   dateLabel: "DD Month 2026",
//   language: "en",
//   titleEn: "Headline text",
//   pullQuoteEn: "One-two sentence quoted passage.",
//   subject: { kind: "Physician", name: "Dr. Shantanu Kumar Gupta", role: "Cataract Surgeon", pageHref: "/about" },
//   topic: "Topic name",
//   topicHref: "/expertise/slug",
//   imageFull: "https://…/screenshot.png",
//   imageClose: "https://…/close-crop.png",
//   epaperUrl: "https://timesofindia.…",
// },
//
// Template C — Broadcast / podcast / TV interview
// -------------------------------------------------------------------
// {
//   id: "podcast-name-XX-mmm-2026",
//   masthead: "Podcast / TV outlet name",
//   mastheadShort: "Short",
//   edition: "Episode title",
//   date: "2026-MM-DD",
//   dateLabel: "DD Month 2026",
//   language: "en",
//   titleEn: "Episode title",
//   pullQuoteEn: "Best 12-20 word quote from the interview.",
//   subject: { kind: "Physician", name: "Dr. Shantanu Kumar Gupta", role: "Cataract Surgeon", pageHref: "/about" },
//   topic: "Interview topic",
//   topicHref: "/press",
//   imageFull: "https://…/thumbnail.png",
//   imageClose: "https://…/thumbnail-close.png",
//   epaperUrl: "https://youtube.com/…",  // or podcast URL
// },
// ---------------------------------------------------------------------------
